import { EnColor } from '../enum/en-color.enum';

export interface IAudio {
    id: number;
    name: string;
    url: string;
    enColor?: EnColor;
}